<template>
  <div class="pages">
    <div class="pageContent infoPage">
      <div class="steps-background-wrapper">
        <img class="steps-background" src="@/assets/img/stepsBg.png" alt="" />
      </div>
      <van-steps :active="stepActive" class="info-steps" v-show="language === 'zh'">
        <van-step :class="{ 'staff-step': !haveActivityPlan }">{{ $t('steps.person') }}</van-step>
        <van-step :class="{ 'staff-step': !haveActivityPlan }">{{ $t('steps.contact') }}</van-step>
        <van-step :class="{ 'staff-step': !haveActivityPlan }">{{ $t('steps.interview') }}</van-step>
        <van-step v-if="haveActivityPlan">{{ $t('steps.active') }}</van-step>
      </van-steps>
      <van-steps :active="stepActive" class="info-steps info-steps-English" v-show="language === 'en'">
        <van-step :class="{ 'staff-step': !haveActivityPlan }">{{ $t('steps.person') }}</van-step>
        <van-step :class="{ 'staff-step': !haveActivityPlan }">{{ $t('steps.contact') }}</van-step>
        <van-step :class="{ 'staff-step': !haveActivityPlan }">{{ $t('steps.interview') }}</van-step>
        <van-step v-if="haveActivityPlan">{{ $t('steps.active') }}</van-step>
      </van-steps>
      <div class="step-content">
        <person-info v-show="stepActive === 0" ref="personInfo" />
        <contact-info v-show="stepActive === 1" ref="contactInfo" />
        <interview-inte v-show="stepActive === 2" ref="interviewInte" />
        <activity-inte v-show="stepActive === 3" ref="activityInte" />
        <div class="information-box button-group" v-if="btnShow">
          <van-button type="info" @click="goNext">{{ stepActive === (haveActivityPlan ? 3 : 2) ? $t('form.label.submit') :
            $t('form.label.next') }}</van-button>
          <van-button plain type="info" v-show="stepActive > 0" @click="goPrev">{{ $t('form.label.previous') }}</van-button>
        </div>
      </div>
    </div>
    <van-dialog v-model="guestInfo" :title="$t('mediaDia.title')" theme="round-button" :confirm-button-text="$t('read')"
      class="notice-dialog">
      <div class="notice-dialog-body">
        <div v-html="$t1(instruction, 'instruction')"></div>
        <!-- <div>{{$t('mediaDia.article1')}}</div>
        <div>{{$t('mediaDia.article2')}}</div>
        <div>{{$t('mediaDia.article3_1')}}</div>
        <div class="bottom">{{$t('mediaDia.article3_2')}}<br/>{{$t('mediaDia.article3_3')}}</div>
        <div>{{$t('mediaDia.article4')}}</div> -->
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getPersonInfo, submitInfo, updateInterview, updateActivity } from '@/api/media'
import { getMediaInstruction, getConferenceInfo } from '@/api/conference'
import PersonInfo from './media/personInfo'
import ContactInfo from './media/contactInfo'
import InterviewInte from './media/interviewInte'
import ActivityInte from './media/activityInte'
import { mapGetters } from 'vuex'
import MonitorKeyboard from '@/utils/monitorKeyboard.js'

export default {
  name: 'mediaInfo',
  components: { PersonInfo, ContactInfo, InterviewInte, ActivityInte },
  data() {
    return {
      stepActive: 0,
      guestInfo: false,
      language: 'zh',
      form: {
        conferenceId: this.$route.params.conferenceId
      },
      instruction: {},
      monitorKeyboard: null,
      inputVal: '',
      btnShow: true
    }
  },
  computed: {
    ...mapGetters(['status', 'activityPlan', 'interviewPlan']),
    haveActivityPlan() {
      return (this.activityPlan && this.activityPlan.length) || (this.interviewPlan && this.interviewPlan.length)
    }
  },
  mounted() {
    if (this.status === 'AUDIT') {
      this.finish()
      return
    }
    this.guestInfo = this.status !== 'ENABLE'
    console.log(this.$i18n.locale)
    this.language = this.$i18n.locale
    if (this.status) {
      this.getPersonInfo()
    } else {
      this.$nextTick(() => {
        this.$refs.personInfo.initForm(this.form)
      })
    }
    this.getMediaInstruction()
  },
  methods: {
    getPersonInfo() {
      getPersonInfo().then(res => {
        this.form = res.data
        this.$nextTick(() => {
          this.$refs.personInfo.initForm(this.form)
        })
      })
    },
    getMediaInstruction() {
      getMediaInstruction({ conferenceId: this.$route.params.conferenceId }).then(res => {
        this.instruction = res.data
      })
    },
    goNext() {
      if (this.stepActive < (this.haveActivityPlan ? 4 : 3)) {
        if (this.stepActive === 0) {
          this.$refs.personInfo.validate().then(() => {
            this.form = Object.assign({}, this.form, this.$refs.personInfo.form)
            this.$refs.contactInfo.initForm(this.form)
            this.stepActive++
          })
        } else if (this.stepActive === 1) {
          this.$refs.contactInfo.validate().then(() => {
            this.form = Object.assign({}, this.form, this.$refs.contactInfo.form)
            this.$refs.interviewInte.initForm(this.form)
            this.stepActive++
          })
        } else if (this.stepActive === 2) {
          this.$refs.interviewInte.validate().then(() => {
            this.form = Object.assign({}, this.form, this.$refs.interviewInte.form)
            if (this.haveActivityPlan) {
              this.$refs.activityInte.initForm(this.form)
              this.stepActive++
            } else {
              if (this.status !== 'ENABLE') {
                getConferenceInfo({ conferenceId: this.$route.params.conferenceId }).then(res => {
                  if (this.$checkTimeBetween(res.data.registerStartTime, res.data.registerEndTime)) {
                    this.submitInfo()
                  } else {
                    this.$notify('注册已结束')
                  }
                })
              } else {
                getConferenceInfo({ conferenceId: this.$route.params.conferenceId }).then(res => {
                  // if (this.$checkTimeBetween(res.data.modificationStartTime, res.data.modificationEndTime)) {
                    this.updateInfo()
                  // } else {
                  //   this.$notify(this.$t3('不在修改信息时间内', 'Not in the time of information modification'))
                  // }
                })
              }
            }
          })
        } else if (this.stepActive === 3) {
          this.$refs.activityInte.validate().then(() => {
            this.form = Object.assign({}, this.form, this.$refs.activityInte.form)
            if (this.status !== 'ENABLE') {
              getConferenceInfo({ conferenceId: this.$route.params.conferenceId }).then(res => {
                if (this.$checkTimeBetween(res.data.registerStartTime, res.data.registerEndTime)) {
                  this.submitInfo()
                } else {
                  this.$notify('注册已结束')
                }
              })
            } else {
              getConferenceInfo({ conferenceId: this.$route.params.conferenceId }).then(res => {
                // if (this.$checkTimeBetween(res.data.modificationStartTime, res.data.modificationEndTime)) {
                  this.updateInfo()
                // } else {
                //   this.$notify(this.$t3('不在修改信息时间内', 'Not in the time of information modification'))
                // }
              })
            }
          })
        }
      }
    },
    goPrev() {
      if (this.stepActive > 0) {
        if (this.stepActive === 1) {
          this.form = Object.assign({}, this.form, this.$refs.contactInfo.form)
          this.$refs.personInfo.initForm(this.form)
          this.stepActive--
        } else if (this.stepActive === 2) {
          this.form = Object.assign({}, this.form, this.$refs.interviewInte.form)
          this.$refs.contactInfo.initForm(this.form)
          this.stepActive--
        } else if (this.stepActive === 3) {
          this.form = Object.assign({}, this.form, this.$refs.activityInte.form)
          this.$refs.interviewInte.initForm(this.form)
          this.stepActive--
        }
      }
    },
    // 提交全部信息
    submitInfo() {
      submitInfo(this.form).then(res => {
        if (res.success) {
          this.$store.commit('user/SET_NEED_UPDATE_INFO', false)
          this.form.id = res.data
          this.finish()
        }
      })
    },
    // 修改部分信息
    updateInfo() {
      this.updateCount = 0
      if (this.haveActivityPlan) {
        updateActivity(this.$refs.activityInte.form).then(res => {
          if (res.success) {
            if (++this.updateCount >= 2) {
              this.finish()
            }
          }
        })
      }
      updateInterview(this.$refs.interviewInte.form).then(res => {
        if (res.success) {
          if (++this.updateCount >= (this.haveActivityPlan ? 2 : 1)) {
            this.finish()
          }
        }
      })
    },
    finish() {
      // TODO 跳转页面
      if (this.status === 'ENABLE') {
        this.$router.push('mediaSuccess')
      } else {
        this.$router.push('mediaConfirm')
      }
    },
    // 监听软键盘是否弹出
    getKeyboardState() {
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {
        // alert('键盘弹出')
        this.btnShow = false
      })

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
        // alert('键盘收起')
        this.btnShow = true
      })
    },
    beforeDestroy() {
      this.monitorKeyboard.onEnd();
    }
  }
}
</script>

<style lang="scss" scoped>
.blue-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  object-fit: contain;
}

.person-steps {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  margin: 30px 0 0;
  padding: 0 5px;

  .line {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 293px;
    height: 1px;
    background: rgba(0, 0, 0, 1);
    z-index: -1;
  }

  .person-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 56px;
    font-size: 14px;
    font-weight: 500;
    color: #000;
    line-height: 20px;

    .circle {
      width: 12px;
      height: 12px;
      border: 2px solid rgba(0, 0, 0, 0.4);
      border-radius: 50%;
    }
  }
}

.information {
  margin: 0 0 0 -15px;
  width: calc(100% + 30px);
  background: #fff;
  border-radius: 10px 10px 0 0;

  .info-title {
    position: relative;
    width: 375px;
    height: 60px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
    }
  }
}</style>